import { SentimentWordConfig } from './types';

export const frSentimentWordConfig: SentimentWordConfig = {
    positiveWords: new Set([
        'actif',
        'agreable',
        'ameliore',
        'amelioration',
        'approuve',
        'bien',
        'bon',
        'brillant',
        'calme',
        'clair',
        'complet',
        'confiant',
        'croissance',
        'efficace',
        'excellent',
        'favorable',
        'fort',
        'heureux',
        'inspirant',
        'joyeux',
        'merveilleux',
        'mieux',
        'optimiste',
        'parfait',
        'positif',
        'pret',
        'progression',
        'resolu',
        'reussi',
        'sain',
        'securise',
        'solide',
        'stable',
        'succes',
        'utile',
        'adorable',
        'apaisant',
        'avance',
        'celebrer',
        'confiance',
        'content',
        'fiable',
        'gagnant',
        'gagne',
        'gentil',
        'joie',
        'leger',
        'libere',
        'meilleur',
        'motivant',
        'precieux',
        'propre',
        'rassure',
        'reconfort',
        'reparation',
        'respecte',
        'serein',
        'soutenu',
        'victoire',
        'vivant',
        'accueillant',
        'adore',
        'aide',
        'aisance',
        'applaudi',
        'apaisement',
        'assure',
        'avantage',
        'beau',
        'bienfait',
        'chaleureux',
        'confort',
        'courageux',
        'detendu',
        'digne',
        'dynamique',
        'encourageant',
        'energie',
        'enthousiaste',
        'equilibre',
        'fiabilite',
        'florissant',
        'gai',
        'harmonieux',
        'honnete',
        'lumineux',
        'merite',
        'motivation',
        'paisible',
        'plaisant',
        'protege',
        'rayonnant',
        'reconnu',
        'renforce',
        'restaure',
        'rassurant',
        'sourire',
        'vaillant',
        'valorise',
        'vivifie',
    ]),
    negativeWords: new Set([
        'angoisse',
        'bloque',
        'casse',
        'catastrophe',
        'chaos',
        'confus',
        'crise',
        'dangereux',
        'defaut',
        'delai',
        'difficile',
        'douleur',
        'echec',
        'echoue',
        'erreur',
        'faible',
        'frustre',
        'grave',
        'haine',
        'inquiet',
        'insecurise',
        'lent',
        'mauvais',
        'menace',
        'panne',
        'peur',
        'pire',
        'probleme',
        'refuse',
        'regression',
        'retard',
        'risque',
        'terrible',
        'triste',
        'urgence',
        'abandon',
        'alarme',
        'bloquant',
        'critique',
        'deprime',
        'desordre',
        'detresse',
        'douloureux',
        'effrayant',
        'epuise',
        'fragile',
        'horrible',
        'hostile',
        'incident',
        'inquietude',
        'instable',
        'lamentable',
        'mal',
        'menacant',
        'panique',
        'perdu',
        'pression',
        'rate',
        'sombre',
        'souci',
        'stress',
        'tendu',
        'toxique',
        'vulnerable',
        'bug',
        'abime',
        'accablant',
        'agressif',
        'amer',
        'anxiete',
        'bloqueur',
        'brise',
        'cassant',
        'danger',
        'decu',
        'degrade',
        'demoralise',
        'derangeant',
        'dur',
        'fatigue',
        'faux',
        'frein',
        'froid',
        'honte',
        'instabilite',
        'inutile',
        'irritant',
        'mort',
        'nocif',
        'oppressant',
        'penible',
        'perte',
        'rouge',
        'ruine',
        'stressant',
        'traumatisant',
        'vexant',
        'violent',
        'brisure',
        'epineux',
    ]),
};
